import "./ReachOut.module.css";
import MainNavigation from "@/reusable_sections/Header";
import LetsTalkProperty from "./sections/LetsTalkProperty";
import AbileneOfficeHub from "./sections/AbileneOfficeHub";
import CommonQuestions from "./sections/CommonQuestions";
import SiteFooter from "@/reusable_sections/Footer";
export default function ReachOutPage() {
  return <div>
      <MainNavigation />
      <LetsTalkProperty />
      <AbileneOfficeHub />
      <CommonQuestions />
      <SiteFooter />
    </div>;
}